<div mat-dialog-title class="flex items-start justify-between w-full mt-3">
    <div class="flex flex-col items-start flex-1">
        <span class="font-bold text-2xl primary-color">
            {{ data?.id ? 'Editar vehículo' : 'Registrar vehículo' }}
        </span>
        <span class="text-sm"> Todos los campos marcados con * son obligatorios. </span>
    </div>
</div>
<mat-dialog-content style="max-height: 50vh !important">
    <form [formGroup]="form" miForm>
        <div
            [miCol]="6"
            miFormField
            [miFormFieldError]="form.get('idTipoVehiculo')?.touched && form.get('idTipoVehiculo')?.invalid ? 'Tipo requerido' : null"
        >
            <label for="idTipoVehiculo">Tipo de vehículo *</label>
            <p-select
                id="idTipoVehiculo"
                formControlName="idTipoVehiculo"
                [options]="vehicleTypes"
                optionLabel="label"
                optionValue="id"
                [filter]="true"
                filterBy="label,id"
                placeholder="Seleccione un tipo de vehículo"
                appendTo="body"
            >
                <ng-template let-option #item> {{ option.label | titlecase }} </ng-template>
                <ng-template let-selectedOption #selectedItem> {{ selectedOption.label | titlecase }} </ng-template>
            </p-select>
        </div>
        <div
            [miCol]="6"
            miFormField
            [miFormFieldError]="form.get('idCiudad')?.touched && form.get('idCiudad')?.invalid ? 'Ciudad requerida' : null"
        >
            <label for="idCiudad">Transito de *</label>
            <p-select
                id="idCiudad"
                formControlName="idCiudad"
                [options]="cities"
                optionLabel="label"
                optionValue="id"
                [filter]="true"
                filterBy="label,id"
                placeholder="Seleccione una ciudad"
                appendTo="body"
            >
                <ng-template let-option #item> {{ option.label | titlecase }} </ng-template>
                <ng-template let-selectedOption #selectedItem> {{ selectedOption.label | titlecase }} </ng-template>
            </p-select>
        </div>
        <div
            [miCol]="6"
            miFormField
            [miFormFieldError]="form.get('marca')?.touched && form.get('marca')?.invalid ? 'Marca requerida' : null"
        >
            <label for="marca">Marca *</label>
            <input id="marca" pInputText formControlName="marca" placeholder="Marca del vehículo" />
        </div>
        <div
            [miCol]="6"
            miFormField
            [miFormFieldError]="form.get('modelo')?.touched && form.get('modelo')?.invalid ? 'Modelo requerido' : null"
        >
            <label for="modelo">Modelo *</label>
            <input id="modelo" pInputText formControlName="modelo" placeholder="Modelo del vehículo" />
        </div>
        <div
            [miCol]="6"
            miFormField
            [miFormFieldError]="form.get('color')?.touched && form.get('color')?.invalid ? 'Color requerido' : null"
        >
            <label for="color">Color *</label>
            <input id="color" pInputText formControlName="color" placeholder="Color del vehículo" />
        </div>
        <div
            [miCol]="6"
            miFormField
            [miFormFieldError]="form.get('placa')?.touched && form.get('placa')?.invalid ? 'Placa requerida' : null"
        >
            <label for="placa">Placa *</label>
            <input id="placa" pInputText formControlName="placa" placeholder="Placa del vehículo" />
        </div>
        <div [miCol]="6" miFormField  [miFormFieldError]="form.get('referencia')?.touched && form.get('referencia')?.invalid ? 'Referencia requerida' : null">
            <label for="referencia">Referencia</label>
            <input id="referencia" pInputText formControlName="referencia" placeholder="Referencia del vehículo" />
        </div>
        <div [miCol]="3" miFormField>
            <mat-checkbox
                color="primary"
                [checked]="esPropio()"
                (change)="esPropio.set($event.checked); form.get('esPropio')?.setValue($event.checked)"
                formControlName="esPropio"
                >¿Es propio?</mat-checkbox
            >
        </div>
<div [miCol]="3" miFormField [miFormFieldError]="form.get('esPrincipal')?.touched && form.get('esPrincipal')?.invalid ? 'Debes indicar si es tu vehículo principal' : null">
    <mat-checkbox color="primary" formControlName="esPrincipal">¿Es principal?</mat-checkbox>
</div>
@if (!esPropio()) {
    <div [miCol]="6" miFormField [miFormFieldError]="form.get('identificacionPropietario')?.touched && form.get('identificacionPropietario')?.invalid ? 'Identificación del propietario requerida' : null">
        <label for="identificacionPropietario">Identificación Propietario</label>
        <input
            id="identificacionPropietario"
            pInputText
            formControlName="identificacionPropietario"
            placeholder="Identificación del propietario"
        />
    </div>
    <div [miCol]="6" miFormField [miFormFieldError]="form.get('nombresPropietario')?.touched && form.get('nombresPropietario')?.invalid ? 'Nombres del propietario requeridos' : null">
        <label for="nombresPropietario">Nombres Propietario</label>
        <input id="nombresPropietario" pInputText formControlName="nombresPropietario" placeholder="Nombres del propietario" />
    </div>
}
    </form>
</mat-dialog-content>
<mat-dialog-actions>
    <div class="flex justify-content-end gap-5">
        <button miButton="back" [miButtonIcon]="'solar:close-circle-broken'" (click)="closeDialog()">Cerrar</button>
        <button miButton="success" (click)="onSave()">{{ data?.id ? 'Actualizar' : 'Guardar' }}</button>
    </div>
</mat-dialog-actions>
